const REQUEST_ID_PATH = ['order', 'price', 'requestId'];
const REQUEST_IS_LOADING_PATH = ['order', 'price', 'isLoading'];

let _ = require('lodash');

let debouncedRequestPrice = _.debounce(requestPrice, 1000);
let treeHelpers = require('../../helpers/tree');
let dateFormatter = require('../dateFormatter');

function getSelectedParameters (state) {
    let rubrics = getSelectedLeafs(state, ['order', 'rubrics', 'tree']);
    let legalEntities = getSelectedLeafs(state, ['order', 'addParams', 'legalEntities', 'tree']);
    let purposes = getSelectedLeafs(state, ['order', 'addParams', 'purposes', 'tree']);
    let mapClasses = getSelectedLeafs(state, ['order', 'addParams', 'mapClasses', 'tree']);
    let paymentTypes = getSelectedLeafs(state, ['order', 'addParams', 'paymentTypes', 'tree']);
    let numberOfEmployees = getSelectedLeafs(state, ['order', 'addParams', 'numberOfEmployees', 'tree']);
    let checkedColumns = _.filter(_.values(state.get(['order', 'addParams', 'exportColumns'])),
        (x) => x.isChecked === true);
    let numberOfFilialsValue = _.get(_.find(state.get(['order', 'addParams', 'numberOfFilials', 'options']),
        (x) => x.isActive === true), 'value');
    let numberOfFilials = numberOfFilialsValue ? Number(numberOfFilialsValue) : null;

    // если Гридер не отображается, то никакие колонки Гридера не выбраны
    // если какие-то колонки Гридера не отображаются, значит они тоже не выбраны
    let greederColumnsSelected = state.get(['order', 'computed', 'isShowGreeder']) === true ?
        _.map(_.filter(_.values(state.get(['order', 'addParams', 'greederColumns', 'value'])),
        (x) => x.isChecked === true), (x) => x.id) :
        [];
    let greederColumnsDisabled = _.map(_.filter(state.get(['order', 'addParams', 'greederColumns', 'view', 'gosReg']),
        (x) => !x.isEnabled), (x) => x.id);
    let greederColumns = _.filter(greederColumnsSelected, (x) => !greederColumnsDisabled.includes(x));

    // пока значения бывают только рейнджовым массивом или массивом дат(даты заполняются кастомной логикой ниже)
    let exportColumns = _.map(checkedColumns, function (x) {
        let column = { columnId: x.id, isMustBeFilled: x.isMustBeFilled };
        if (x.value) {
            column.value = [_.get(x.value, '0', null), _.get(x.value, '1', null)];
        }
        return column;
    });

    let columnsConfig = state.get(['order', 'originalParameters', 'exportColumns', 'columns']);
    // (костыль) пока считаем, что колонка фильтрации по дате(filterType: 'IsInRangeDatetime') может быть только одна
    let from = dateFormatter.getFormattedDate(state.get(['order', 'addParams', 'datepicker', 'value']));
    let to = dateFormatter.getFormattedDate(state.get(['order', 'addParams', 'datepicker2', 'value']));
    if (from !== null || to !== null) {
        let dateColumnId = _.find(columnsConfig, { filterType: 'IsInRangeDatetime' }).id;
        let dateColumn = _.find(exportColumns, { columnId: dateColumnId });
        dateColumn.value = [from, to];
        dateColumn.isMustBeFilled = true;
    }

    // преобразуем строки в double
    let doubleRangeIds = _.map(_.filter(columnsConfig, { filterType: 'IsInRangeDouble' }), (x) => x.id);
    let doubleRangeColumns = _.filter(exportColumns, (x) => _.includes(doubleRangeIds, x.columnId));
    _.forEach(doubleRangeColumns, (x) => {
        if (x.value) {
            if (x.value[0] && x.value[0] instanceof String) {
                x.value[0] = parseFloat(x.value[0].replace(',', '.'));
            }
            if (x.value[1] && x.value[1] instanceof String) {
                x.value[1] = parseFloat(x.value[1].replace(',', '.'));
            }
        }
    });

    let params = state.get(['order', 'addParams', 'params']);
    let dataVersion = state.get(['order', 'originalParameters', 'dataVersion']);
    let configVersion = state.get(['order', 'originalParameters', 'configVersion']);
    let onlyHeadCards = state.get(['order', 'addParams', 'onlyHeadCards']);
    let includeArchiveInn = state.get(['order', 'addParams', 'includeArchiveInn']);

    let selectedParams = Object.assign({}, params, { rubrics, legalEntities, purposes, mapClasses, paymentTypes,
        numberOfEmployees, numberOfFilials, exportColumns, greederColumns, onlyHeadCards, dataVersion, configVersion, includeArchiveInn });

    // заполняем параметры для фильтрации по карте, или бранчам или нас.пунктам
    let tab = state.get(['order', 'cities', 'tab']);
    if (tab === 'map') {
        selectedParams.mapFilter = state.get(['order', 'cities', 'mapFilter']) ||
            state.get(['order', 'cities', 'mapFilterInit']);
    } else if (tab === 'branches') {
        let calcOnlyDefaultCities = state.get(['order', 'cities', 'calcOnlyDefaultCities']);
        let branches = getSelectedLeafs(state, ['order', 'branches', 'tree']);
        if (calcOnlyDefaultCities) {
            let originalBranches = state.get(['order', 'originalParameters', 'branches']);
            selectedParams.cities =
                _.map(_.filter(originalBranches, (x) => branches.includes(x.code)), (x) => x.defaultCityId);
        } else {
            selectedParams.branches = branches;
        }
    } else {
        selectedParams.cities = getSelectedLeafs(state, ['order', 'cities', 'tree']);
    }

    return selectedParams;
}

function requestPrice (args, state, output, { context, locator }) {
    let api = locator.resolve('api');

    let orderTypeId = state.get(['order', 'typeId']);
    if (orderTypeId === undefined) {
        orderTypeId = 1;
    }

    let selectedParams = getSelectedParameters(state);

    // если рубрики не выбраны, то цену считать не надо
    if (orderTypeId !== 3 && (!selectedParams.rubrics || selectedParams.rubrics.length <= 0)) {
        output.requiredParametersNotFilled();
        return;
    }
    // если города или карта не выбраны, то цену считать не надо
    if ((!selectedParams.cities || selectedParams.cities.length <= 0) && !selectedParams.mapFilter
        && !selectedParams.branches) {
        output.requiredParametersNotFilled();
        return;
    }

    // если есть ошибки валидации, то цену считать не надо
    let exportColumns = state.get(['order', 'addParams', 'exportColumns']);
    let errors = _.map(exportColumns, 'error');
    // если в ошибке пустой объект, значит ошибки нет
    if (_.some(errors, (x) => x && (typeof x !== 'object' || Object.keys(x).length !== 0))) {
        return;
    }

    let isPersistent = state.get(['order', 'settings', 'shouldPersist']);
    if (isPersistent) {
        storeCurrentState(selectedParams, context, locator);
    }

    let requestId = state.get(REQUEST_ID_PATH).toString();
    let payload = Object.assign({ requestId }, selectedParams);

    let request = api.getOrderPrice(context, locator, payload, orderTypeId);

    request
        .then((response) => {
            let code = _.get(response, 'status.code');

            if (code !== 200) {
                output.error({ error: code });
                return;
            }
            let price = _.get(response, 'content');
            output.success({ price });
        })
        .catch((error) => output.error({ error }));
}

function getSelectedLeafs (state, basePath) {
    let leafs = state.get(basePath.concat('computed', 'leafs'));
    let selected = state.get(basePath.concat('selected'));

    return treeHelpers.getSelectedLeafs(leafs, selected);
}

function storeCurrentState (selectedParams, context, locator) {
    if (context.isServer) {
        return;
    }
    let window = locator.resolve('window');
    window.localStorage.setItem('selected_params', JSON.stringify(selectedParams));
}

function setPrice ({ price }, state) {
    state.set(['order', 'price', 'data'], price);
    state.set(REQUEST_IS_LOADING_PATH, false);
}

module.exports = {
    calcPrice (args, state, output, { context, locator }) {
        debouncedRequestPrice(args, state, output, { context, locator });
    },

    prepareToRequest (args, state) {
        let previous = state.get(REQUEST_ID_PATH) || 0;
        let value = previous % Number.MAX_SAFE_INTEGER + 1;
        state.set(REQUEST_ID_PATH, value);
        state.set(REQUEST_IS_LOADING_PATH, true);
    },

    setPrice,

    setPriceIfRequestIdIsValid ({ price }, state) {
        let expectedRequestId = state.get(REQUEST_ID_PATH).toString();
        let actualRequestId = price.requestId;
        if (actualRequestId === expectedRequestId) {
            setPrice({ price }, state);
        }
    },

    initPrice (args, state) {
        const price = { totalPrice: 0, rowPrice: 0, rowAmount: 0 };

        state.set(['order', 'price', 'data'], price);
    },

    setIsLoading (value) {
        return (args, state) => state.set(REQUEST_IS_LOADING_PATH, value);
    },

    isZeroPrice ({ price }, state, output) {
        if (price.total.totalPrice <= 0) {
            output.yes();
        } else {
            output.no();
        }
    },

    getSelectedParameters
};



// WEBPACK FOOTER //
// ./actions/order/price.js